import { useApolloClient } from "@apollo/client";
import { useCallback } from "react";
import { fetchUnknownDishTypes } from "slices/dishesSlice";

import { LocalDishType } from "types/mainTypes";

import { useAppDispatch } from "./utilsHooks/storeHooks";

export const useFetchUnknownDishTypes = () => {
	const apolloClient = useApolloClient();
	const dispatch = useAppDispatch();

	const getUnknownDishTypes = useCallback(
		(orderDishTypes: Array<LocalDishType>) => {
			return dispatch(
				fetchUnknownDishTypes({
					orderDishTypes,
					apolloClient,
				}),
			);
		},
		[dispatch],
	);

	return { getUnknownDishTypes };
};
